import { CommonModule }            from '@angular/common';
import { NgModule }                from '@angular/core';
import { FilterModule }            from '@app/shared/list-operations/components/filter/filter.module';
import { PaginationModule }        from '@app/shared/list-operations/components/pagination/pagination.module';
import { SearchModule }            from '@app/shared/list-operations/components/search/search.module';
import { SortModule }              from '@app/shared/list-operations/components/sort/sort.module';
import { ListOperationsComponent } from '@app/shared/list-operations/list-operations.component';

@NgModule( {
	declarations: [
		ListOperationsComponent
	],
	imports: [
		// Angular
		CommonModule,

		// Shared ListOps
		FilterModule,
		PaginationModule,
		SearchModule,
		SortModule
	],
	exports: [
		ListOperationsComponent
	]
} )
export class ListOperationsModule {}
